import { render, staticRenderFns } from "./svgTorob.vue?vue&type=template&id=6da88b9e"
import script from "./svgTorob.vue?vue&type=script&lang=js"
export * from "./svgTorob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports